spApp.controller('MyResultsController', ['$scope', '$http','$window', function ($scope, $http, $window) {
    $scope.params = {};
  }]);
